import {
  Groupsword,
  StorybackgroundImage,
  buttonfactions,
  chaseImg,
  fractionImg,
  gameplay,
  hammerImg,
  landloard,
  megame,
  storyImg,
  storycard,
  swordImg,
} from "../../images/general";
import React from "react";
import scrollTo from "gatsby-plugin-smoothscroll";

const Story = () => {
  return (
    <>
      <section
        className=""
        style={{ backgroundImage: `url(${StorybackgroundImage})` }}
      >
        {/* Desktop */}
        <div className="sm:grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-7xl mx-auto px-4 pb-44 md:pb-36 hidden">
          <div
            className="rounded shadow md:-mt-48 hover:scale-105 transition duration-300 cursor-pointer"
            data-sal="slide-right"
            data-sal-delay="300"
            data-sal-easing="ease"
            onClick={() => scrollTo("#theStory")}
          >
            <img src={storyImg} className="mx-auto w-full" alt="story" />
            <img
              src={swordImg}
              className="mx-auto w-24 pb-6 -mt-[12.5rem] md:-mt-[14.5rem]"
              alt="sword"
            />
            <h2 className="font-cinzel text-xl md:text-[40px] font-bold leading-relaxed pb-5 text-white text-center ">
              The story
            </h2>
          </div>
          <div
            className="rounded shadow md:-mt-[13.4rem] sm:-mt-[1.2rem] hover:scale-105 transition duration-300 cursor-pointer"
            data-sal="slide-down"
            data-sal-delay="300"
            data-sal-easing="ease"
            onClick={() => scrollTo("#gamePlay")}
          >
            <img src={megame} className="mx-auto w-full" alt="" />
            <img
              src={hammerImg}
              className="mx-auto w-24 pb-6 -mt-[12.5rem] md:-mt-[14.5rem]"
              alt=""
            />
            <h2 className="font-cinzel text-xl md:text-[40px] font-bold leading-relaxed pb-5 text-white text-center">
              The Gameplay
            </h2>
          </div>
          <div
            className="rounded shadow lg:-mt-[13.2rem] hover:scale-105 transition duration-300 cursor-pointer"
            data-sal="slide-left"
            data-sal-delay="300"
            data-sal-easing="ease"
            onClick={() => scrollTo("#landLord")}
          >
            <img src={fractionImg} className="mx-auto w-full" alt="" />
            <img
              src={chaseImg}
              className="mx-auto w-24 -mt-[12.5rem] md:-mt-[14.5rem]"
              alt=""
            />
            <h2 className="font-cinzel text-xl md:text-[40px] font-bold leading-relaxed pb-5 text-white text-center">
              Become a Landlord
            </h2>
          </div>
        </div>
        {/* Mobile */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-1 max-w-7xl mx-auto px-4 pb-9 md:pb-36 sm:hidden sm:pt-0 pt-4">
          <div
            className="rounded shadow md:-mt-48"
            onClick={() => scrollTo("#theStory")}
          >
            <img src={storycard} className="mx-auto " alt="" />
            <img
              src={swordImg}
              className="mx-auto -mt-[1.5rem] md:-mt-[14.5rem]"
              alt=""
            />
            {/* <h2 className="font-cinzel text-xl md:text-[40px] font-bold leading-relaxed pb-5 text-white text-center ">
              The story
            </h2> */}
          </div>
          <div
            className="rounded shadow md:-mt-[13.4rem] sm:-mt-[1.2rem]"
            onClick={() => scrollTo("#gamePlay")}
          >
            <img src={gameplay} className="mx-auto " alt="" />
            <img
              src={hammerImg}
              className="mx-auto -mt-[1.5rem] md:-mt-[14.5rem]"
              alt=""
            />
            {/* <h2 className="font-cinzel text-xl md:text-[40px] font-bold leading-relaxed pb-5 text-white text-center">
              Factions
            </h2> */}
          </div>
          <div
            className="rounded shadow lg:-mt-[13.2rem]"
            onClick={() => scrollTo("#landLord")}
          >
            <img src={landloard} className="mx-auto" alt="" />
            <img
              src={chaseImg}
              className="mx-auto w-24 -mt-[1.5rem] md:-mt-[14.5rem]"
              alt=""
            />
            {/* <h2 className="font-cinzel text-xl md:text-[40px] font-bold leading-relaxed pb-5 text-white text-center">
              ME Gameplay
            </h2> */}
          </div>
        </div>
        <div
          className="text-center relative"
          data-sal="fade-in"
          data-sal-delay="300"
          data-sal-easing="ease"
        >
          <img src={Groupsword} className="mx-auto pb-7" />
          <h4 className="sm:text-2xl text-sm font-cinzel text-[#ACD6E9] font-bold leading-8 pb-7">
            The story
          </h4>
          <h3 className="sm:text-7xl text-[28px] font-cinzel text-white font-bold sm:leading-[64px] leading-7 sm:max-w-[54rem] sm:w-full w-80 mx-auto sm:pb-48 pb-32">
            A single man changes the course of{" "}
            <span className="text-[#ACD6E9] "> History</span>
          </h3>
        </div>
      </section>
    </>
  );
};

export default Story;
